module.exports = "/images/es.svg";